import React, { useState } from "react";
import { AsesorSelectorContext as Context } from "./index";
import { updateContactAsesorsDataApi } from "../Api/UpdateContact.js";

import { getErrorsArrayMessageFromHtttpResponse } from "../../../Shared/Utils/errorUtils.js";

import {
  showAsesorContactsApi,
  showContactAsesorsApi,
} from "../Api/ShowContact.js";

const AsesorSelectorProvider = (props) => {
  const [contactAsesors, setContactAsesors] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);

  //lista los asesores de un contacto
  const getContactAsesors = async (id) => {
    let response = await showContactAsesorsApi(id);

    if (response?.result && response?.result == "success") {
      setContactAsesors(
        response.data.map((asesor) => ({
          ...asesor,
          name: `${asesor.first_name} ${asesor.last_name}`,
        }))
      ); // Actualizar el estado con un nuevo array transformado

      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  //edit item
  const updateContactAsesors = async (data, id) => {
    let response = await updateContactAsesorsDataApi(data, id);

    if (response?.result && response?.result == "success") {
      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        contactAsesors,
        updateContactAsesors,
        setContactAsesors,
        getContactAsesors,
        apiErrors,
        setApiErrors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default AsesorSelectorProvider;
